import { Tooltip } from "@/components/Tooltip";
import { faEye, faEyeSlash } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IProps {
  showPassword: boolean;
  onClick: () => void;
}

const PasswordSwitcherButton = ({ showPassword, onClick }: IProps) => (
  <button
    type="button"
    onClick={onClick}
    className="ml-2 px-2 focus:text-primary focus:outline-primary">
    <Tooltip content={showPassword ? "Hide" : "Show"}>
      <FontAwesomeIcon fixedWidth icon={showPassword ? faEyeSlash : faEye} />
    </Tooltip>
  </button>
);

export default PasswordSwitcherButton;
